module.exports = __webpack_public_path__ + "img/gs.0ee2d8c9.svg";